<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header" style="display: flex; justify-content: space-between">
      <div>
        <vxe-button type="primary" class="vxe-btn" @click="checkDialog(3)" v-if="displayOk" :loading="btnLoading">审核
        </vxe-button>
        <!-- <vxe-button
          type="primary"
          class="vxe-btn"
          @click="toView"
          v-if="+this.project.projectjjbgstatus === 3"
          :loading="btnLoading"
          >预览</vxe-button
        > -->
        <span class="status">{{ project.projectjjbgstatusdesc }}</span>
      </div>
      <div>
        <!-- <vxe-button type="primary" class="vxe-btn" @click="auditLogListVisible = true" :loading="btnLoading">查看审核日志</vxe-button> -->
        <vxe-button type="primary" class="vxe-btn" @click="toViewTmpl(1)" :loading="btnLoading">查看采购报告</vxe-button>
        <vxe-button type="primary" class="vxe-btn" @click="toViewTmpl(2)" :loading="btnLoading" v-if="+this.project.projectstatus !== 20">查看成交确认函</vxe-button>
      </div>
    </div>
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ project.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-value">{{ project.projectname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ project.pcomfullname }}</div>
          </div>
        </div>
        <div class="view-row" v-if="project.acomfullname">
          <div class="view-field">
            <div class="view-label">代理人</div>
            <div class="view-value">{{ project.acomfullname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">提交人</div>
            <div class="view-value">{{ project.cgtjusername }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">联系电话</div>
            <div class="view-value">{{ project.cgtjusertel }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">提交时间</div>
            <div class="view-value">
              {{ project.projectjjbgtime | longDate }}
            </div>
          </div>
        </div>
        <div class="view-row" v-if="project.projectsubmitdesc">
          <div class="view-field">
            <div class="view-label">提交意见</div>
            <div class="view-value">{{ project.projectsubmitdesc }}</div>
          </div>
        </div>
        <div class="view-row" v-if="project.cgshusername">
          <div class="view-field">
            <div class="view-label">审核人</div>
            <div class="view-value">{{ project.cgshusername }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">联系电话</div>
            <div class="view-value">{{ project.cgshusertel }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">审核时间</div>
            <div class="view-value">
              {{ project.projectjjbgchecktime | longDate }}
            </div>
          </div>
        </div>
        <div class="view-row" v-if="project.projectcgcheckdesc">
          <div class="view-field">
            <div class="view-label">审核意见</div>
            <div class="view-value">{{ project.projectcgcheckdesc }}</div>
          </div>
        </div>
        <div class="split-line"></div>
        <div class="view-row">
          <div>
            <div style="display: flex">
              <div style="margin-right: 20px">报告内容</div>
              <div v-if="appendList && appendList.length" class="view-filelist">
                <div v-for="(item, index) in appendList" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl)">
                    <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename | toolongOmitted
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div v-html="project.projectjjcontent" style="margin:10px;" class="content"></div>
            </div>
          </div>
        </div>
        <div class="split-line"></div>
        <div v-if="+this.project.projectstatus !== 20">
          <div>
            <div style="display: flex">
              <div style="margin-right: 20px">成交确认函</div>
              <div v-if="appendCGFJ && appendCGFJ.length" class="view-filelist">
                <div v-for="(item, index) in appendCGFJ" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl)">
                    <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename | toolongOmitted
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div v-html="project.projectconfirmletter" style="margin:10px;" class="content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="status === 2 ? '提交' : '审核'" :visible.sync="dialogVisible"
      width="720px" :modal-append-to-body="false">
      <div v-if="status === 3">
        <div class="view-container">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">报告结果</div>
                <div class="view-value">
                  <el-radio v-model="projectjjbgstatus" :label="3">同意</el-radio>
                  <el-radio v-model="projectjjbgstatus" :label="4">不同意</el-radio>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">审核意见</div>
                <div style="width: 380px">
                  <el-input type="textarea" :autosize="{ minRows: 5 }" :rows="5" v-model.trim="checkdesc"
                    :maxlength="255" show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row" v-if="+this.project.projectstatus !== 20">
              <div class="view-field">
                <div class="view-label">成交确认函</div>
                <div class="" style="width: 300px">
                  <div class="file">
                    <div class="uploadbtn">
                      <upload-btn @changed="setfile" text="上传附件"></upload-btn>
                    </div>
                    <div v-if="appendCJList.length" class="filelist">
                      <div v-for="(item, index) in appendCJList" :key="index" class="fileitem" style="padding-left: 0">
                        <div class="name" @click="downFile(item.appendurl)">
                          <a :src="uploadAddr + item.appendurl">{{
                              item.appendfilename
                          }}</a>
                        </div>
                        <div class="btn" @click="delappend(item)">
                          <span>删除</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button type="primary" class="vxe-btn" @click="submit(status)" :loading="btnLoading">保存
                  </vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="status === 2">
        <div class="view-container">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">提交意见</div>
                <div style="width: 380px">
                  <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="checkdesc" :maxlength="255"
                    show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button type="primary" class="vxe-btn" @click="submit(status)" :loading="btnLoading">确认提交
                  </vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="审核日志" @open="auditDialogOpen" :loading="auditDialogLoading" :visible.sync="auditLogListVisible" width="50%">
      <audit-log-list :auditLogList="auditLogList"></audit-log-list>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import config from "../../assets/config";
import common from "@/mixin/common";
import dayjs from "dayjs";
import uploadBtn from "../common/uploadBtn";
import moment from "moment";
import AuditLogList from "../jjgl/auditLogList.vue";

export default {
  name: "projectReportW",
  mixins: [common],
  data() {
    return {
      loading: false,
      btnLoading: false,
      checkdesc: "",
      dialogVisible: false,
      type: this.$route.params.type,
      project: {},
      status: 0,
      projectjjbgstatus: "",
      appendList: [],
      appendCJList: [],
      appendCGFJ: [],
      auditDialogLoading: false,
      auditLogListVisible: false,
      auditLogList: []
    };
  },
  created() { },
  async activated() {
    await this.init();
    await this.getModel();
  },
  components: { uploadBtn, AuditLogList },
  mounted() { },
  filters: {
    toolongOmitted(val) {
      if (val) {
        if (val.length > 30) {
          return val.substring(0, 15) + "...";
        } else {
          return val;
        }
      }
      return val;
    },
    longDate(value) {
      return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    displayOk() {
      if (+this.project.projectjjbgstatus < 3) {
        if (+this.project.projecttype === 2) {
          return true;
        } else if (
          +this.project.projecttype === 1 &&
          +this.project.projectjjbgstatus === 2 &&
          +this.project.cositemapsynergyway === 2
        ) {
          return true;
        } else if (
          +this.type === 4 &&
          +this.$store.getters.loginUser.comtype === 2 &&
          +this.project.projectjjbgstatus === 2
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  deactivated() {
    this.$destroy();
  },
  methods: {
    async getAuditLogList() {
      this.auditDialogLoading = true
      return request({
        url: '/auditlog/getAuditLog',
        method: 'get',
        params: {
          auditlogfromid: this.$route.params.projectid,
          auditlogcosid: this.$store.getters.loginUser.cosid,
          auditlogcode: 20
        }
      })
      
    },
    async auditDialogOpen () {
      const data  = await this.getAuditLogList()
      this.auditDialogLoading = false
      this.auditLogList = data
    },
    init() {
      this.appendList = [];
      this.appendCGFJ = [];
    },
    async getAppendList() {
      let res = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: {
          appendfromid: this.$route.params.projectid,
          appendfromtype: 20,
        },
      });
      this.appendList = res;
    },
    async getAppendCGFJ() {
      let res = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: {
          appendfromid: this.$route.params.projectid,
          appendfromtype: 23,
        },
      });
      this.appendCGFJ = res;
    },
    async getModel() {
      this.loading = true;
      this.btnLoading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getProjectInfoById",
        params: { projectid: this.$route.params.projectid },
      });
      this.project = res[0];
      await this.getAppendList();
      await this.getAppendCGFJ();
      this.btnLoading = false;
      this.loading = false;
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: 23,
        appendtype: "100",
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendCJList.push(append);
    },
    async submit(status) {
      if (status === 3) {
        if (+this.projectjjbgstatus < 3) {
          this.$message.warning(`请选择报告结果！`);
          return;
        }
        if (+this.projectjjbgstatus === 4 && !this.checkdesc) {
          this.$message.warning(`请输入审核意见！`);
          return;
        }
      }
      if (status === 2) {
        this.project.projectjjbgstatus = status;
      } else {
        this.project.projectjjbgstatus = this.projectjjbgstatus;
      }

      // if(+this.projectjjbgstatus === 4){
      //     this.appendCJList = []
      // }
      if (+this.projectjjbgstatus === 3 && +this.appendCJList.length === 0 && +this.project.projectstatus !== 20) {
        // this.$message.warning(`请上传成交确认函！`);
        // return;
        this.$confirm('您还未上传成交确认函,是否确认提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await this.sumitFun()
        })
      } else {
        await this.sumitFun()
      }

    },
    async sumitFun() {
      let data = await request({
        url: "/xmgl/project/projectSubmitJjbg",
        method: "post",
        data: {
          projecttype: +this.project.projecttype,
          projectid: this.project.projectid,
          userid: this.$store.getters.loginUser.userid,
          projectpuserid: +this.$store.getters.loginUser.comtype === 1 ? this.project.projectpuserid : this.$store.getters.loginUser.userid,
          projectjjbgstatus: this.project.projectjjbgstatus,
          projectcgcheckdesc: this.checkdesc,
          projectsubmitdesc: this.checkdesc,
          projectjjcontent: this.project.projectjjcontent,
          projectconfirmletter: this.project.projectconfirmletter,
          appendCJList: this.appendCJList,
          projectname: this.project.projectname,
          username: this.project.ausername,
          cosid: this.$store.getters.loginUser.cosid,
          wxopenid: this.project.auserwxopenid
        },
      });
      if (data.issuccess === 1) {
        let projectjjbgstatusdesc = status === 2 ? "提交" : "保存";
        this.$message.success(`${projectjjbgstatusdesc}成功！`);
        this.getModel();
        this.dialogVisible = false;
        this.status = 0;
      } else {
        this.$message.error(`${projectjjbgstatusdesc}失败！`);
      }
    },
    async checkDialog(status) {
      this.dialogVisible = true;
      this.status = status;
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendCJList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendCJList.splice(index, 1);
        })
        .catch(() => { });
    },
    async toView() {
      let { href } = this.$router.resolve({
        name: "projectReportP",
        query: { projectid: this.project.projectid },
      });
      window.open(href, "_blank");
    },
    async toViewTmpl(type) {
      let { href } = this.$router.resolve({
        name: "contentview",
        query: { type, projectid: this.project.projectid },
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/filelist";
@import "../../styles/table.scss";

.main {

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }

  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 690px;
  }

  .file {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;

    .uploadbtn {
      display: flex;

      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
}

.view-filelist {

  //width: 50%;
  .view-fileitem {
    display: flex;
    text-align: left;

    //padding-left: 10px;
    .view-filename {
      color: #409eff;
      cursor: pointer;
      flex: 1;
    }

    .view-filebtn {
      padding: 0 30px;

      span {
        color: #2f74ff;
        cursor: pointer;
      }
    }
  }
}
</style>




